import React, { useEffect, useState } from 'react';
import { CreateFeatureDialog } from '../../../components';
import {
    createStepStyles,
    stepMenuItems,
} from './create-or-update-step-helper';
import { PIPELINES_AND_STEPS_PATHS } from 'constants/pipelines-and-steps-paths';
import { useLocation, useNavigate } from 'react-router-dom';
import { useServicesEnabled } from 'core/contexts';

export const CreateStep = (): React.JSX.Element => {
    const { isServiceEnabledFor } = useServicesEnabled();
    const isDataPipelineServiceEnabled = isServiceEnabledFor('DATA_PIPELINE');
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const option = queryParams.get('option');
    const [selectedOption, setSelectedOption] = useState<string>(
        option || stepMenuItems[0].navigationPath
    );

    useEffect(() => {
        if (option) {
            const selectedTab = stepMenuItems.find(
                (item) => item.title === option
            );
            if (selectedTab) {
                setSelectedOption(selectedTab?.navigationPath);
            }
        }
    }, [option]);

    const handleClose = (): void => {
        navigate(PIPELINES_AND_STEPS_PATHS.LANDING_PAGE);
    };

    const handleNext = (): void => {
        navigate(selectedOption);
    };

    if (!isDataPipelineServiceEnabled) {
        navigate(PIPELINES_AND_STEPS_PATHS.LANDING_PAGE);
        return <></>;
    }

    return (
        <CreateFeatureDialog
            headingText='Create Step'
            items={stepMenuItems}
            selectedOption={selectedOption}
            handleClose={handleClose}
            handleNext={handleNext}
            setSelectedOption={setSelectedOption}
            displayPermissionDialog={false}
            handlePermissionDialogClose={(): void => {}}
            menuItemStyles={createStepStyles.menuItemStyles}
            listItemStyles={createStepStyles.listItemStyles}
        />
    );
};
